import { type ReactNode, useMemo } from 'react';

import { type AppRole } from 'connect-graphql/generated';

import { ConditionallyRender } from '@craft/ui/components/util';

import { useSelectedRole } from '@/src/features/auth/hooks';
import { type AccessType, type AccessTypeId, hasAccessType } from '@/src/roleAuthorizers';

interface HasAnyRoleProps {
  readonly accessTypes?: never;
  readonly children: ReactNode;
  readonly roles: AppRole[];
}

interface HasAnyAccessTypeProps {
  readonly accessTypes: (AccessType | AccessTypeId)[];
  readonly children: ReactNode;
  readonly roles?: never;
}

export type HasAnyAccessProps = HasAnyAccessTypeProps | HasAnyRoleProps;

export const HasAnyAccess: React.FC<HasAnyAccessProps> = ({ accessTypes, children, roles }) => {
  const { organizationType, role: userRole } = useSelectedRole();

  const show = useMemo(() => {
    if (roles !== undefined) {
      return roles.some(role => role === userRole);
    }
    return hasAccessType(accessTypes, { organizationType, role: userRole });
  }, [accessTypes, roles, userRole, organizationType]);

  return <ConditionallyRender show={show}>{children}</ConditionallyRender>;
};
